module.exports = __webpack_public_path__ + "static/media/TASNIM ATAR.2952f43c.png";